import { render, staticRenderFns } from "./JsonShowData.vue?vue&type=template&id=fafc9b84&scoped=true"
import script from "./JsonShowData.vue?vue&type=script&lang=js"
export * from "./JsonShowData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fafc9b84",
  null
  
)

export default component.exports